export enum PosterImageType {
  Facebook = 'facebook',
  Generic = 'generic',
  Twitter = 'twitter',
}
